import React, { Component } from 'react';
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import { Grid, Paper, Button, CircularProgress, Select, MenuItem } from '@material-ui/core';
import { Table, TableCell, TableHead, TableBody, TableRow, IconButton, Divider, Typography } from '@material-ui/core';
import { Check, Close, Search } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import TablePagination from '@material-ui/core/TablePagination';

import "./index.css";
import ApiCoag from "../../api/ApiCoag";
import CustomTableHead from "../generales/CustomTableHead";



const regex = /^(?=\S)(?:(?<=\s)\S+|\S+(?=\s))$/;


class SearchAgents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: "",
      isSearch: false,
      selectAgent: null,
      showSearchResult: false,
     showSearchResultInitial:this.props.showSearchResultInitial,
      searchResult:  this.props.searchResultInitial,//[],
      currentPage: 0,
      rowsPerPage: 10,
      totalRecords: 100,
      totalPages: 4,
      searchOptions: [
        "Nombre",
        "Nif"
      ],
      selectedSearchOption: "Nombre"
    }
  }

  obtenerTextoConUnEspacioAlLado(texto) {
    return texto.replace(/\s+/g, ' '); 
  }

  handleChangePage = async (event, page) => {
    this.state.currentPage = page;
    await this.handleSearch(page);
  };

  handleChangeRowsPerPage = async (event) => {
    this.state.rowsPerPage = event.target.value;
    await this.handleSearch(0);
  };

  handleSearchQueryChange = event => {
    this.setState({
      searchQuery: event.target.value
    });
  }

  handleBlur = () => event => {          
      
    this.setState({
      searchQuery: this.obtenerTextoConUnEspacioAlLado(event.target.value)     
    });
}


  async handleSearch() {
    this.setState({ isSearch: true });
    let search = await ApiCoag.general.buscador(this.state.searchQuery, this.props.tipoBusqueda, (this.state.currentPage + 1), this.state.rowsPerPage);
    let tipoBusqueda = this.props.tipoBusqueda;
    if (search && search[tipoBusqueda]) {
      let pagination = search.Paginacion && search.Paginacion.length > 0
        ? search.Paginacion[0] : {};
      this.setState({
        showSearchResult: true,
        isSearch: false,
        searchResult: search[tipoBusqueda],
        totalRecords: pagination.Numero_Total_Registros,
        totalPages: pagination.Numero_Paginas,
        showSearchResultInitial:false        
      });
    }
    else
      this.setState({ showSearchResult: true, isSearch: false });
  }

  selectAgent = (agent, showSearchResult = false) => {
    if (showSearchResult) {
      this.setState({ showSearchResult: false, selectAgent: agent });
    }
    this.props.selectAgent(agent);
    this.setState({ selectAgent: agent });
  }

  handleCancel() {
    this.setState({ searchQuery: "", showSearchResult: false })
  }

  handleSearchOption = event => {
    this.setState({ selectedSearchOption: event.target.value });
  };


  renderSearchResults() {
    let { classes } = this.props;
    let { selectAgent } = this.state;

    return (
      (this.state.showSearchResult || this.state.showSearchResultInitial) &&
      <div>
        <Divider />
        <Typography variant="h6" gutterBottom className="text-left p-2">
       { this.state.showSearchResultInitial ? <Translate id="languages.generalText.sugeridos" /> : <Translate id="languages.generalText.resultados" />}
        </Typography>
        <Divider />
        <Table >
          <TableHead>
            <TableRow className={"head-height-agentes"}>
              <CustomTableHead className="text-uppercase px-3">{this.props.tipoBusqueda=='Colegiados'?<Translate id="languages.agentes.numeroColegiado" />:'NIF'}</CustomTableHead>
              <CustomTableHead className="text-uppercase">
                <Translate id="languages.agentes.tableColumnName" />
              </CustomTableHead>
              <CustomTableHead></CustomTableHead>
            </TableRow>
          </TableHead>

          <TableBody >
            {
               this.state.searchResult.length === 0 ?
                <TableRow>
                  <TableCell colSpan={3} className="text-center">
                    0 <Translate id="languages.generalText.resultados" />
                  </TableCell>
                </TableRow>
                : ( this.state.searchResult.length === 0 ?   
                   //Si hay solo uno podemos cargarlo ya si ponemos === 1 arriba sin necesidad de seleccionarlo en la lista
                                 this.selectAgent(this.state.searchResult[0]) 
                  
                  : 
                  this.state.searchResult.map((row, index) => {
                  var isSelect = selectAgent && (selectAgent.Nif === row.Nif);
                  return (
                    <TableRow key={index}
                      style={{ border: isSelect ? "2px solid dodgerblue" : "" }}>
                      <TableCell component="th" scope="row" className="px-3">
                        {this.props.tipoBusqueda=='Colegiados'?row.Id_Colegiado:row.Nif}
                      </TableCell>
                      <TableCell>{`${row.Nombre_Completo}`}</TableCell>
                      <TableCell className="px-2 py-0 button-column-short">
                        <IconButton className={"button-edit"} aria-label="Edit" color="primary"
                          onClick={() => { this.selectAgent(row) }}>
                          <Check />
                        </IconButton >
                      </TableCell>
                    </TableRow>               
                    );
                 
                   }) 
                
                )
            }
          </TableBody>
        </Table>
        { /*si no hay mas de 10 qu es el tamaño de página no mostramos info de paginación */
        (this.state.totalRecords>10 && !this.props.showSearchResultInitial) ?
        
        <Translate>
          { 
            ({ translate }) => <TablePagination
              labelRowsPerPage={`${this.props.tipoBusqueda} ${translate("languages.promotores.itemsPerPage")}`}
              rowsPerPageOptions={[10, 25]}
              component="div"
              count={this.state.totalRecords}
              rowsPerPage={this.state.rowsPerPage}
              page={this.state.currentPage}
              backIconButtonProps={{
                'aria-label': 'Previous Page',
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page',
              }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage} />
          }
        </Translate>
       : null }
      </div>
    )
  }

  renderSearchBox = () => {
    let { classes } = this.props;
    return (
      <div>
        <Paper className={'text-center'}>
        {<ValidatorForm ref="form" onSubmit={() => { this.handleSearch() }}>
            <Translate>
              {
                ({ translate }) => <TextValidator
                  value={this.state.searchQuery} 
                  onChange={this.handleSearchQueryChange}
                  onBlur={this.handleBlur()}
                  onKeyPress={event => {
                    if (event.key === 'Enter') {
                      this.handleSearch();
                    }
                  }}
                  label={translate("languages.agentes.searchLabelBox")}
                  className={"text-field-busqueda"}
                  validators={['required']}
                  errorMessages={[translate("languages.agentes.searchValidation")]}
                  autoFocus = {true}   /* md foco */
                  name="searchQuery">
                  
                </TextValidator>
              }
            </Translate>


            <Select hidden={true}
              className={"text-field-busqueda"}
              value={this.state.selectedSearchOption}
              onChange={this.handleSearchOption}>
              {this.state.searchOptions.map((value, index) => {
                return <MenuItem key={index} value={value}>{value}</MenuItem>
              })}
            </Select>

            <Grid item xs={12} className="py-3">
              <div style={{ display: "inline-flex", alignItems: "center" }}>
                
              { /* md si no se ha buscado no hace falta limpiar */
              this.state.showSearchResult  ?  <Button color="primary" className={`${"button"} py-0`} disabled={this.state.isSearch}
                  onClick={() => { this.handleCancel() }}>
                  <Translate id="languages.generalButton.limpiar" />
                  <Close />
                </Button>
                :
                null
            }
                <Button variant="contained" color="primary" className={`${"button"} py-0`} disabled={this.state.isSearch}
                  type="submit">
                  <Translate id="languages.agentes.search" /><Search />
                </Button>
                {this.state.isSearch && <CircularProgress size={24} />}
              </div>
            </Grid>
          </ValidatorForm>
        }
          <Grid item xs={12}>
            {this.renderSearchResults()}
          </Grid>
        </Paper>
        {/* se debe poder añadir antes de buscar, caso más normal 
        this.props.allowAdd && this.state.showSearchResult ? <Button color="primary" className={classes.button}*/
        this.props.allowAdd   ? <Button color="primary" className={"button"}
          onClick={() => {
            this.selectAgent({
              "Id_Entidad": -1, "Id_Tipo_Entidad": 1, "Id_Autonomia": 71,
              "Id_Pais": 100, "Id_Provincia": 15,
            }, true);
            this.props.addPromotorChange();
          }}>
          <Translate id="languages.generalButton.annadirNuevo" />
        </Button> : ""}
      </div>

    );
  }

  render() {
    return (
      <Grid container spacing={8} className="py-2">
        <Grid item xs={12}>
          {this.renderSearchBox()}
        </Grid>
      </Grid>
    )
  }
}

SearchAgents.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withLocalize(SearchAgents);